const SEO = [
	{
		page: "home",
		description:
			"I am a frontend developer with reactJS and nextJS. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
		keywords: ["Galvin", "Galvin J", "Galvin Jason"],
	},

	{
		page: "about",
		description:
			"I am a frontend developer with reactJS and nextJS. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
		keywords: ["Galvin", "Galvin J", "Galvin Jason"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Galvin", "Galvin J", "Galvin Jason"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
		keywords: ["Galvin", "Galvin J", "Galvin Jason"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Galvin", "Galvin J", "Galvin Jason"],
	},
];

export default SEO;
